var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showTableView)?_c('TableView',{attrs:{"col":_vm.columns,"getData":_vm.getData,"Options":{tblClass:'eachThree table-striped table-bordered'}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }